import type { ReactNode } from 'react';

/** Rend le gras **texte** en <strong>, sans HTML brut (sûr). */
function inline(texte: string, cle: string): ReactNode[] {
  return texte.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={`${cle}-${i}`}>{part.slice(2, -2)}</strong>;
    }
    return <span key={`${cle}-${i}`}>{part}</span>;
  });
}

/**
 * Rendu markdown minimal et sûr : gras, listes numérotées/à puces, paragraphes.
 * Couvre le style des réponses de l'assistant sans injection HTML (anti-XSS).
 */
export function Markdown({ texte }: { texte: string }) {
  const lignes = texte.split('\n');
  const blocs: ReactNode[] = [];
  let liste: ReactNode[] | null = null;

  const fermerListe = () => {
    if (liste) {
      blocs.push(
        <ul className="md-liste" key={`ul-${blocs.length}`}>
          {liste}
        </ul>,
      );
      liste = null;
    }
  };

  lignes.forEach((ligne, i) => {
    const item = ligne.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
    if (item) {
      liste ??= [];
      liste.push(<li key={`li-${i}`}>{inline(item[1] ?? '', `li-${i}`)}</li>);
    } else if (ligne.trim() === '') {
      fermerListe();
    } else {
      fermerListe();
      blocs.push(
        <p className="md-p" key={`p-${i}`}>
          {inline(ligne, `p-${i}`)}
        </p>,
      );
    }
  });
  fermerListe();

  return <div className="md">{blocs}</div>;
}
